// Helper function to convert string to camelCase
export const camelCase = str => {
  return str
    .replace(/[-_\s]+(.)?/g, (_, c) => (c ? c.toUpperCase() : ''))
    .replace(/^./, c => c.toLowerCase())
}

// Helper function to set nested property in an object
const setNestedProperty = (obj, path, value) => {
  const keys = path.split('.')
  const lastKey = keys.pop()
  const target = keys.reduce((acc, key) => {
    if (!acc[key] || typeof acc[key] !== 'object') {
      acc[key] = {}
    }
    return acc[key]
  }, obj)
  target[lastKey] = value
}

export const errorsFromJson = (json = '{}') => {
  // Return null for empty, null, or undefined values
  if (!json || json === '{}') {
    return null
  }

  // If already an object, process it directly
  if (typeof json === 'object' && json !== null) {
    const camelizedErrors = {}
    Object.entries(json).forEach(([key, value]) => {
      const camelizedKey = key
        .split('.')
        .map(camelCase)
        .join('.')
      camelizedErrors[camelizedKey] = value
    })

    const result = {}
    Object.entries(camelizedErrors).forEach(([key, value]) => {
      setNestedProperty(result, key, value)
    })

    return result
  }

  // Try to parse JSON string
  try {
    const parsed = JSON.parse(json)
    const camelizedErrors = {}
    Object.entries(parsed).forEach(([key, value]) => {
      const camelizedKey = key
        .split('.')
        .map(camelCase)
        .join('.')
      camelizedErrors[camelizedKey] = value
    })

    const result = {}
    Object.entries(camelizedErrors).forEach(([key, value]) => {
      setNestedProperty(result, key, value)
    })

    return result
  } catch (error) {
    // If JSON parsing fails, return null (not a valid JSON error object)
    console.warn('errorsFromJson: Failed to parse JSON:', json)
    return null
  }
}
